// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__kJUSO","mobileWrapper":"Layout_mobileWrapper__7eZJW","content":"Layout_content__X7SjR"};